"use client";

import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { ArrowLeft } from "@phosphor-icons/react/dist/ssr";
import { useClientSnapshot } from "@/lib/hooks/use-client-snapshot";

export default function BackButton() {
  const router = useRouter();
  const t = useTranslations("auth");
  // History length at mount — read SSR-safely (false on the server, so the
  // button never appears in prerendered HTML), no effect/setState needed.
  const hasHistory = useClientSnapshot(() => window.history.length > 1, false);

  if (!hasHistory) return null;

  return (
    <button
      onClick={() => router.back()}
      className="mb-21 flex items-center gap-5 text-xs font-semibold uppercase tracking-[0.08em] text-navy/50 transition-opacity hover:opacity-60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold"
    >
      <ArrowLeft size={13} aria-hidden="true" />
      {t("back")}
    </button>
  );
}
